import {call, takeLatest} from "redux-saga/effects";
import {
  requestOTPAsync,
  validateOTPAsync,
  verifyPhoneNumberAsync,
} from "../AsyncActions/login.async";
import * as actions from "../action.constants";

function* requestOTP(action) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(requestOTPAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* validateOTP(action) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(validateOTPAsync, payload);
    if (response) {
      callback(response.data);
    }
  } catch (e) {
    return e;
  }
}

function* verifyPhoneNumber(action) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(verifyPhoneNumberAsync, payload);
    if (response) {
      callback(response.data);
    }
  } catch (e) {
    return e;
  }
}

export function* groupSaga() {
  yield takeLatest(actions.REQUEST_OTP, requestOTP);
  yield takeLatest(actions.VALIDATE_OTP, validateOTP);
  yield takeLatest(actions.VERIFY_PHONE_NUMBER, verifyPhoneNumber);
}
